"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBePartiallyChecked = toBePartiallyChecked;
var _utils = require("./utils");
function toBePartiallyChecked(element) {
  var _this = this;
  (0, _utils.checkHtmlElement)(element, toBePartiallyChecked, this);
  var isValidInput = function isValidInput() {
    return element.tagName.toLowerCase() === 'input' && element.type === 'checkbox';
  };
  var isValidAriaElement = function isValidAriaElement() {
    return element.getAttribute('role') === 'checkbox';
  };
  if (!isValidInput() && !isValidAriaElement()) {
    return {
      pass: false,
      message: function message() {
        return 'only inputs with type="checkbox" or elements with role="checkbox" and a valid aria-checked attribute can be used with .toBePartiallyChecked(). Use .toHaveValue() instead';
      }
    };
  }
  var isPartiallyChecked = function isPartiallyChecked() {
    var isAriaMixed = element.getAttribute('aria-checked') === 'mixed';
    if (isValidInput()) {
      return element.indeterminate || isAriaMixed;
    }
    return isAriaMixed;
  };
  return {
    pass: isPartiallyChecked(),
    message: function message() {
      var is = isPartiallyChecked() ? 'is' : 'is not';
      return [_this.utils.matcherHint("".concat(_this.isNot ? '.not' : '', ".toBePartiallyChecked"), 'element', ''), '', "Received element ".concat(is, " partially checked:"), "  ".concat(_this.utils.printReceived(element.cloneNode(false)))].join('\n');
    }
  };
}